module.exports = __webpack_public_path__ + "static/media/partner_dianxin.9594c37c.png";